import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { Box, Button, Grid, Icon } from "@material-ui/core";
import { loadItemsPedido } from "src/store/actions/pedidos";
import { InputMask, Modal } from "src/components";

const ModalImprimir = ({ open, close }) => {
  const dispatch = useDispatch();
  const { pedido, items_pedido } = useSelector((state) => state.pedidos);
  const { empresa_atual } = useSelector((state) => state.usuario);

  useEffect(() => {
    if (!open) return;

    dispatch(loadItemsPedido(pedido.id));
  }, [dispatch, pedido.id, open]);

  const handlePrint = (elementId, uniqueIframeId) => {
    const content = document.getElementById(elementId);
    const iframe = document.createElement("iframe");
    iframe.setAttribute("title", uniqueIframeId);
    iframe.setAttribute("id", uniqueIframeId);
    iframe.setAttribute(
      "style",
      "height: 0px; width: 0px; position: absolute;"
    );
    document.body.appendChild(iframe);
    const pri = iframe.contentWindow;

    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };

  return (
    <Modal open={open} width={520} height="60vh" style={{ padding: 0 }}>
      <div
        id="iframe"
        style={{ width: 500, display: "flex", flexDirection: "column" }}
      >
        <div style={{ width: 500, display: "flex", flexDirection: "column" }}>
          <span
            style={{
              color: "#3e3e3e",
              width: "100%",
              padding: 5,
              textAlign: "center",
              fontSize: 15,
            }}
          >
            {empresa_atual.nome_fantasia}
          </span>
          <span
            style={{
              color: "#3e3e3e",
              width: "100%",
              textAlign: "center",
              fontSize: 12,
              padding: 0,
              margin: 0,
            }}
          >
            {`${empresa_atual.endereco}, ${empresa_atual.numero}  ${
              empresa_atual.complemento ? empresa_atual.complemento : ""
            }`}
          </span>
          <span
            style={{
              color: "#3e3e3e",
              width: "100%",
              textAlign: "center",
              fontSize: 12,
              padding: 0,
              margin: 0,
            }}
          >
            {`${empresa_atual.cep} | ${empresa_atual.bairro} | ${empresa_atual.cidade}-${empresa_atual.uf}`}
          </span>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignContent: "space-between",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "left",
              fontSize: 12,
            }}
          >
            {`CNPJ: ${empresa_atual.cpf_cnpj}`}
          </span>
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "right",
              fontSize: 12,
            }}
          >
            {dayjs(pedido.created_at).format("DD/MM/YYYY HH:mm:ss")}
          </span>
        </div>
        <div
          style={{
            width: "100%",
            height: 1,
            borderBottomColor: "#3e3e3e",
            borderBottomWidth: 1,
            borderBottomStyle: "dotted",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        ></div>
        <div
          style={{
            width: 500,
            display: "flex",
            flexDirection: "column",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <span
            style={{
              width: "100%",
              color: "#3e3e3e",
              fontSize: 12,
              textAlign: "left",
              fontWeight: "bold",
            }}
          >
            Dados do Cliente
          </span>
          <span
            style={{
              width: "100%",
              color: "#3e3e3e",
              fontSize: 12,
              textAlign: "left",
            }}
          >
            {pedido.cliente_nome}
          </span>
          <span
            style={{
              width: "100%",
              color: "#3e3e3e",
              fontSize: 12,
              textAlign: "left",
            }}
          >
            {`${pedido.cliente_endereco}, ${pedido.cliente_numero}  ${
              pedido.cliente_complemento ? pedido.cliente_complemento : ""
            }`}
          </span>
          <span
            style={{
              width: "100%",
              color: "#3e3e3e",
              fontSize: 12,
              textAlign: "left",
            }}
          >
            {`${pedido.cliente_cep} | ${pedido.cliente_bairro} | ${pedido.cliente_cidade}-${pedido.cliente_uf}`}
          </span>
        </div>
        <div
          style={{
            width: "100%",
            height: 1,
            borderBottomColor: "#3e3e3e",
            borderBottomWidth: 1,
            borderBottomStyle: "dotted",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        ></div>
        <div
          style={{
            width: 500,
            display: "flex",
            flexDirection: "column",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <span
            style={{
              width: 500,
              paddingLeft: 5,
              paddingRight: 5,
              color: "#3e3e3e",
              textAlign: "center",
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            PEDIDO DELIVERY
          </span>
          <table style={{ width: 500 }}>
            <thead>
              <tr
                style={{
                  width: 500,
                  borderBottomColor: "#3e3e3e",
                  borderBottomWidth: 1,
                  borderBottomStyle: "dotted",
                }}
              >
                <th
                  style={{
                    width: 50,
                    color: "#3e3e3e",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  Item
                </th>
                <th
                  style={{
                    width: 50,
                    color: "#3e3e3e",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  Cód.
                </th>
                <th
                  style={{
                    width: 300,
                    color: "#3e3e3e",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  Desc.
                </th>
                <th
                  style={{
                    width: 100,
                    color: "#3e3e3e",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  Valor
                </th>
              </tr>
            </thead>
            <tbody>
              {items_pedido.map((item, index) => (
                <>
                  <tr
                    style={{
                      width: 500,
                      borderBottomColor: "#3e3e3e",
                      borderBottomWidth: 1,
                      borderBottomStyle: "dotted",
                    }}
                  >
                    <td
                      style={{
                        width: 50,
                        color: "#3e3e3e",
                        fontSize: 12,
                        textAlign: "left",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        width: 50,
                        color: "#3e3e3e",
                        fontSize: 12,
                        textAlign: "left",
                      }}
                    >
                      {item.produto_id}
                    </td>
                    <td
                      style={{
                        width: 300,
                        color: "#3e3e3e",
                        fontSize: 12,
                        textAlign: "left",
                      }}
                    >
                      {item.titulo} - ({item.qtde}x)
                    </td>
                    <td
                      style={{
                        width: 100,
                        color: "#3e3e3e",
                        fontSize: 12,
                        textAlign: "right",
                      }}
                    >
                      <InputMask
                        type="cash"
                        displayType="text"
                        value={item.preco}
                        style={{ fontSize: 12, marginLeft: 10, marginTop: 5 }}
                      />
                    </td>
                  </tr>
                  {item.acompanhamentos.map((acom, i) => (
                    <tr
                      style={{
                        width: 500,
                        borderBottomColor: "#3e3e3e",
                        borderBottomWidth: 1,
                        borderBottomStyle: "dotted",
                      }}
                    >
                      <td
                        style={{
                          width: 50,
                          color: "#3e3e3e",
                          fontSize: 12,
                          textAlign: "left",
                        }}
                      >
                        {`${index + 1}-${i + 1}`}
                      </td>
                      <td
                        colspan="2"
                        style={{
                          color: "#3e3e3e",
                          fontSize: 10,
                          textAlign: "justify",
                          fontWeight: "bold",
                        }}
                      >
                        {acom.titulo} - ({acom.qtde}x)
                      </td>
                      <td
                        style={{
                          width: 100,
                          color: "#3e3e3e",
                          fontSize: 12,
                          textAlign: "right",
                          fontWeight: "bold",
                        }}
                      >
                        <InputMask
                          type="cash"
                          displayType="text"
                          value={acom.preco}
                          style={{
                            fontSize: 12,
                            marginLeft: 10,
                            marginTop: 5,
                            fontWeight: "bold",
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                  {item.observacao && (
                    <tr
                      style={{
                        width: 500,
                        borderBottomColor: "#3e3e3e",
                        borderBottomWidth: 1,
                        borderBottomStyle: "dotted",
                      }}
                    >
                      <td
                        style={{
                          width: 50,
                          color: "#3e3e3e",
                          fontSize: 12,
                          textAlign: "left",
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        colspan="3"
                        style={{
                          width: 500,
                          color: "#3e3e3e",
                          fontSize: 10,
                          textAlign: "justify",
                          fontWeight: "bold",
                        }}
                      >
                        {item.observacao}
                      </td>
                    </tr>
                  )}
                </>
              ))}
            </tbody>
          </table>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignContent: "space-between",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "left",
              fontSize: 11,
            }}
          >
            Subtotal
          </span>
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "right",
              fontSize: 11,
            }}
          >
            <InputMask
              type="cash"
              displayType="text"
              value={pedido.valor_items}
            />
          </span>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignContent: "space-between",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "left",
              fontSize: 11,
            }}
          >
            Desconto
          </span>
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "right",
              fontSize: 11,
            }}
          >
            <InputMask
              type="cash"
              displayType="text"
              value={pedido.valor_cashback}
            />
          </span>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignContent: "space-between",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "left",
              fontSize: 11,
            }}
          >
            Taxa de Entrega
          </span>
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "right",
              fontSize: 11,
            }}
          >
            <InputMask
              type="cash"
              displayType="text"
              value={pedido.valor_entrega}
            />
          </span>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignContent: "space-between",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "left",
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            Total
          </span>
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "right",
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            <InputMask
              type="cash"
              displayType="text"
              value={
                pedido.valor_total +
                pedido.valor_entrega -
                pedido.valor_cashback
              }
            />
          </span>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignContent: "space-between",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "left",
              fontSize: 11,
            }}
          >
            Cashback
          </span>
          <span
            style={{
              color: "#3e3e3e",
              width: "50%",
              textAlign: "right",
              fontSize: 11,
            }}
          >
            <InputMask
              type="cash"
              displayType="text"
              value={pedido.cashback_receber}
            />
          </span>
        </div>
        {pedido.status_pagamento === "PAGO NO APLICATIVO" && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flex: 1,
              flexDirection: "row",
              alignContent: "space-between",
              paddingLeft: 5,
              paddingRight: 5,
            }}
          >
            <span
              style={{
                marginTop: 20,
                width: "100%",
                color: "#3e3e3e",
                textAlign: "center",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              NÃO RECEBER, PEDIDO PAGO PELO APLICATIVO
            </span>
          </div>
        )}
      </div>
      <Grid container justify="flex-end">
        <Button
          color="primary"
          size="small"
          onClick={() => handlePrint("iframe")}
        >
          &nbsp;Imprimir
        </Button>
        <Button color="primary" size="small" onClick={() => close()}>
          &nbsp;Fechar
        </Button>
      </Grid>
    </Modal>
  );
};

export default ModalImprimir;
